import clsx from 'clsx';
import { useState } from 'react';
import { Button } from './Form';

function stringify(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function JsonView({
  value,
  className,
  collapsedHeight = '10rem',
  label,
}: {
  value: unknown;
  className?: string;
  collapsedHeight?: string;
  label?: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const content = stringify(value);
  const long = content.length > 320 || content.split('\n').length > 8;

  return (
    <div className={clsx('min-w-0', className)}>
      {label ? <div className="mb-1 text-[11px] uppercase tracking-wide text-zinc-500">{label}</div> : null}
      <pre
        className="scroll-thin overflow-auto rounded-lg border border-zinc-800 bg-zinc-950 p-2 text-[11px] leading-relaxed text-zinc-300"
        style={long && !expanded ? { maxHeight: collapsedHeight } : undefined}
      >
        {content}
      </pre>
      {long ? (
        <Button size="sm" variant="ghost" className="mt-1" onClick={() => setExpanded((v) => !v)}>
          {expanded ? 'Свернуть' : 'Развернуть'}
        </Button>
      ) : null}
    </div>
  );
}
